<ion-row
  *ngIf="!displayMobileView"
  class="content"
  routerLink="/app/market/order/{{ row.id }}"
>
  <ion-col size="1">
    {{ row.id }}
  </ion-col>

  <ion-col size="3">
    {{ row.dateCreated | dateSti }}
  </ion-col>

  <ion-col size="3">
    {{ row.companyProvider.name }}
  </ion-col>

  <ion-col size="2">
    {{ row.orderCost | currency: " " }} {{ "PLN" | translate }}
  </ion-col>

  <ion-col size="3">
    {{ statusName(row.status) }}
  </ion-col>
</ion-row>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="/app/market/order/{{ row.id }}"
>
  <ion-card-content class="vertical-padding">
    <ion-grid class="no-padding-grid order-view-header">
      <ion-row>
        <ion-col size="6">
          <ion-text class="txt-info">{{ row.companyProvider.name }}</ion-text>
        </ion-col>
        <ion-col size="6">
          <div class="remove-container ion-text-end">
            <ion-text class="txt-info">{{ row.id }}</ion-text>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-header>
    <ion-card-title>{{ statusName(row.status) }}</ion-card-title>
    <ion-card-subtitle *ngIf="row.description">
      {{ row.description }}
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-grid class="no-padding-grid order-mobile">
      <ion-row>
        <ion-col size="6">
          <ion-icon mobile src="assets/icons/calendar-gray.svg"></ion-icon>
          <ion-text class="inv-info">{{ row.dateCreated | dateSti }}</ion-text>
        </ion-col>
        <ion-col size="6">
          <ion-icon mobile src="assets/icons/money.svg"></ion-icon>
          <ion-text class="inv-info"
            >{{ row.orderCost | currency: " " }}
            {{ "PLN" | translate }}</ion-text
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
